import { render, staticRenderFns } from "./HospDocMaintain.vue?vue&type=template&id=b568baaa&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./HospDocMaintain.vue?vue&type=script&lang=js"
export * from "./HospDocMaintain.vue?vue&type=script&lang=js"
import style0 from "./HospDocMaintain.vue?vue&type=style&index=0&id=b568baaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b568baaa",
  null
  
)

export default component.exports